<template>
  <div>
    <!--타이틀-->
    <div class="title-bar title-h4" style="height: 43px; margin: 0 !important">템플릿 타임라인</div>
    <el-tabs v-model="timelineTab" @tab-click="loadData" :stretch="true">
      <el-tab-pane label="수행 결과" name="result" style="width: 100%">
        <!-- 색상 범례 -->
        <div class="mr-b10">
          <div v-for="dot in resultDotList" :key="dot.resultFlag" class="mr-r25" style="display: inline-block">
            <el-checkbox v-model="resultFlags[dot.resultFlag]" @change="loadData">
              <span class="icon-dot mr-t4" :style="{ backgroundColor: dot.color }"></span> {{ dot.label }}
            </el-checkbox>
          </div>
        </div>
        <div style="height: 615px">
          <el-scrollbar class="timeline trigger-timeline">
            <dl v-for="(timeline, index) in timelineList" :key="index">
              <dt>
                <span class="icon-dot" :style="{ backgroundColor: resultDotColors[timeline.resultFlag] }"></span>
                <span class="title c-pointer" style="max-width: 200px" @click="onClickTimeline(timeline)">{{`[${timeline.grpName}] ${timeline.triggerName}`}}</span>
              </dt>
              <dd>{{ getDateFormatter(timeline.startDatetime) }}</dd>
              <div class="border" />
            </dl>
          </el-scrollbar>
        </div>
      </el-tab-pane>
      <el-tab-pane label="수행 예정" name="scheduled" style="width: 100%">
        <!-- 색상 범례 -->
        <!-- <div class="mr-b10">
          <div class="mr-r25" style="display: inline-block">
            <span class="icon-dot mr-t4" :style="{ backgroundColor: 'rgb(86, 139, 210)' }"></span> 수행 예정
          </div>
        </div> -->
        <div style="height: 615px">
          <el-scrollbar class="timeline trigger-timeline">
            <dl v-for="(timeline, index) in timelineList" :key="index">
              <dt>
                <span class="icon-dot" :style="{ backgroundColor: 'rgb(200, 200, 200)' }"></span>
                <span class="title c-pointer" style="max-width: 200px" @click="onClickTimeline">{{`[${timeline.grpName}] ${timeline.triggerName}`}}</span>
              </dt>
              <dd>{{ getDateFormatter(timeline.nextScheduledTime) }}</dd>
              <div class="border" />
            </dl>
          </el-scrollbar>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { reduce, isNil } from 'lodash';
import { mapGetters } from 'vuex';
import { getDateToString } from '@/utils/date';
import { EMPTY_TEXT } from '@/utils/string';
import amsSummaryApi from '@/api/ams/summary';

export default {
  name: 'WTriggerTimeline',
  props: {
    tabActive: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      timelineTab: 'result',
      resultFlags: { S: true, F: true, PS: true },
      timelineList: [],
      resultDotList: [
        { resultFlag: 'S', label: '성공', color: 'rgb(86, 139, 210)' },
        { resultFlag: 'F', label: '실패', color: 'rgb(253, 116, 132)' },
        { resultFlag: 'PS', label: '부분성공', color: 'rgb(247, 186, 0)' },
        // { resultFlag: 'I', label: '진행중', color: 'rgb(209, 209, 209)' },
      ],
      resultStatusObject: {
        S: {
          tagType: 'info',
          type: 'resultStatus',
          selected: true,
          label: '성공',
          name: '성공',
        },
        PS: {
          tagType: 'info',
          type: 'resultStatus',
          selected: true,
          label: '부분성공',
          name: '부분성공',
        },
        F: {
          tagType: 'info',
          type: 'resultStatus',
          selected: true,
          label: '실패',
          name: '실패',
        },
      },
    };
  },
  computed: {
    /**
     * resultDotList를 resultFlag별 색상 map으로 가공
     * @author jeee12
     * @return {[type]} [description]
     */
    resultDotColors() {
      return this.resultDotList.reduce((acc, val) => {
        acc[val.resultFlag] = val.color;
        return acc;
      }, {});
    },
    ...mapGetters(['analysisDateParams']),
  },
  watch: {
    tabActive: {
      handler(flag) {
        if (flag) {
          this.loadData();
        }
      },
      immediate: true,
    },
    analysisDateParams() {
      this.loadData();
    },
  },
  methods: {
    getDateToString,
    loadData() {
      if (!this.tabActive) return;
      if (this.timelineTab === 'result') {
        const resultStatusFilters = reduce(this.resultFlags, (acc, val, key) => {
          if (val) acc.push(key);
          return acc;
        }, []);
        amsSummaryApi.getTriggerTimelineData({
          startDatetime: this.analysisDateParams.startDatetime,
          endDatetime: this.analysisDateParams.endDatetime,
          resultStatusFilters,
        }).then((response) => {
          if (response.data.success) {
            this.timelineList = response.data.data;
          }
        });
      } else if (this.timelineTab === 'scheduled') {
        amsSummaryApi.getScheduledTriggerExecutionList({}).then((response) => {
          if (response.data.success) {
            this.timelineList = response.data.data;
          }
        });
      }
    },
    /**
     * 타임라인 클릭 시 수행결과, 수행 탭으로 이동
     * @author jeee12
     * @return {[type]} [description]
     */
    onClickTimeline(timeline) {
      if (this.timelineTab === 'result') {
        const trigger = {
          name: timeline.triggerName,
          tagType: 'success',
          type: 'triggerList',
          selected: true,
          triggerId: timeline.triggerId,
        };
        this.$emit('change-active-tab', 'result', 'TRIGGER', [trigger, this.resultStatusObject[timeline.resultFlag]]);
      } else if (this.timelineTab === 'scheduled') {
        this.$emit('change-active-tab', 'execution');
      }
    },
    getDateFormatter(datetime) {
      if (!isNil(datetime)) {
        return getDateToString(datetime);
      }
      return EMPTY_TEXT;
    },
  },
};
</script>

<style>
.trigger-timeline .el-scrollbar__wrap > .el-scrollbar__view {
  width: calc(100% - 10px) !important;
}
</style>



// WEBPACK FOOTER //
// src/views/work/popup/components/ExecutionSummary/components/TriggerTimeline.vue